import type { EntityConfig } from "../hooks/useEntity";

export const organizerItemEntityConfig: EntityConfig = {
  name: "OrganizerItem",
  orderBy: "dueDate ASC",
  properties: {
    title: {
      type: "string",
      description: "User-facing label for the organizer entry",
    },
    tone: {
      type: "string",
      enum: ["experiential", "assignment", "meeting"],
      description: "Visual grouping used by the teaser chips",
    },
    course: {
      type: "string",
      description: "Course identifier that owns this entry",
    },
    instructor: {
      type: "string",
      description: "Primary instructor or facilitator",
    },
    dueDate: {
      type: "string",
      format: "date-time",
      description: "ISO timestamp for when the item is due",
    },
    notes: {
      type: "string",
      description: "Optional supporting details surfaced in the full organizer",
    },
    thesisSummary: {
      type: "string",
      description: "Synced thesis statement snippet",
    },
    linkedDocumentId: {
      type: "integer",
      description: "Document ID this organizer item is tied to",
    },
  },
  required: ["title", "tone", "dueDate"],
};
